<template>
    <div class="intervencao-page">
      <Menu-component />
      <div class="container">
          <div id="mapa">
              <Brasil-component v-if="setorAtivo == 1 || setorAtivo == 7"/>
              <CentroOeste-component v-if="setorAtivo == 2"/>
              <NordesteSete-component v-if="setorAtivo == 3"/>
              <NordesteMeridional-component v-if="setorAtivo == 4"/>
              <Sudeste-component v-if="setorAtivo == 5"/>
              <Sul-component v-if="setorAtivo == 6"/>
          </div>
          <div class="tabs">
            <Tabs-component />
          </div>
          <div class="footer-menu">
              <MenuMobile-component />
          </div>
          <router-link tag="button" class="btn-green monitoramento" to="monitoramento">O Monitoramento</router-link>
      </div>
    </div>
</template>


<script>
import { mapState } from 'vuex'

import Menu from '@/components/Menu'
import Tabs from '@/components/Tabs'
import MenuMobileIntervencoes from '@/components/MenuMobileIntervencoes'
import Brasil from '@/components/Mapas/Brasil'
import NordesteSete from '@/components/Mapas/NordesteSete'
import NordesteMeridional from '@/components/Mapas/NordesteMeridional'
import CentroOeste from '@/components/Mapas/CentroOeste'
import Sudeste from '@/components/Mapas/Sudeste'
import Sul from '@/components/Mapas/Sul'

export default {
   components: {
    'Menu-component': Menu,
    'Tabs-component': Tabs,
    'NordesteMeridional-component': NordesteMeridional,
    'MenuMobile-component': MenuMobileIntervencoes,
    'Brasil-component': Brasil,
    'CentroOeste-component': CentroOeste,
    'NordesteSete-component': NordesteSete,
    'Sudeste-component': Sudeste,
    'Sul-component': Sul
  },

  computed: {
      ...mapState({
          'setorAtivo': state => state.Layout.setorAtivo
      })
  }
}
</script>


<style lang="scss" scoped>

#mapa {
    position: relative;
}
button {
          cursor: pointer;
          margin: 90px 0 0 auto;
          bottom: 58px;
          &::after {
            content: "";
            position: absolute;
            right: 50px;
            top: 17px;
            background-repeat: no-repeat;
            background-image: url(../assets/seta-direita-branca.svg);
            width: 9px;
            height: 14px;

            @include media_tablet() {
              top: 22px;
              right: 35px;
            }
          }

          @include media_tablet() {
            margin: 15px 0 0 0;
            width: 100%;
            border-radius: 30px 30px 0 0;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          @media (max-height:  900px) and (min-width: 1200px)   {
                cursor: pointer;
                margin: 90px 0 0 auto;
                position: absolute;
                right: 20vw;
          }
        }
.intervencao-page {
    position: relative;
    &::after {
        content: '';
        background-image: url(../assets/assets-esquerda.svg);
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        top: 0;
        left: 0px;
        height: 60vh;
        width: 10vh;
        @include media_tablet() {
          display: none;
        }
    }

    &::before {
        content: '';
        background-image: url(../assets/assets-direita.svg);
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        top: 189px;
        right: 0px;
        height: 995px;
        width: 21vh;
        @include media_tablet() {
          display: none;
        }
    }

    .title-section::after {
        @include media_tablet() {
            top: 45px;
        }
    }
}


.container {
  margin: 0 auto;
  width: 1234px;
  @include media_tablet() {
        width: 100%;
  }
}
</style>
